/**
 * Store a student-portal login the same way the username form does.
 * Returns the path to open, or null when the account must use another login page.
 */
export function persistPortalSession(responseData) {
  const { access_token, role } = responseData;
  const roleModify = (responseData.portal_role || role?.name || role || "")
    .toString()
    .toLowerCase()
    .trim();

  localStorage.setItem("token", access_token);
  localStorage.setItem("role", roleModify);
  localStorage.setItem("userData", JSON.stringify(responseData));

  try {
    Object.keys(sessionStorage)
      .filter((k) => k === "exam_mode_cache" || k.startsWith("exam_mode_cache_"))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch (_) {
    /* ignore */
  }

  if (roleModify === "parent" || roleModify === "student") {
    localStorage.removeItem("admin-token");
  }
  if (roleModify === "parent" && Array.isArray(responseData.permissions)) {
    localStorage.setItem("parent-permissions", JSON.stringify(responseData.permissions));
  } else {
    localStorage.removeItem("parent-permissions");
  }
  if (roleModify === "student" && Array.isArray(responseData.permissions)) {
    localStorage.setItem("student-permissions", JSON.stringify(responseData.permissions));
  } else {
    localStorage.removeItem("student-permissions");
  }
  if (responseData.is_tester && Array.isArray(responseData.tester_permissions)) {
    localStorage.setItem("tester-permissions", JSON.stringify(responseData.tester_permissions));
  } else {
    localStorage.removeItem("tester-permissions");
  }
  if (responseData.must_change_password !== undefined) {
    localStorage.setItem("mustChangePassword", responseData.must_change_password ? "1" : "0");
  }
  if (roleModify === "student") {
    localStorage.removeItem("student-subscription-lock");
    if (responseData.is_allow_mobile) {
      localStorage.setItem("student-use-mobile-dashboard", "1");
    }
  }

  if (roleModify === "tester") {
    localStorage.setItem("admin-token", access_token);
    const testerPerms = Array.isArray(responseData.permissions)
      ? responseData.permissions
      : responseData.tester_permissions;
    if (Array.isArray(testerPerms)) {
      localStorage.setItem("tester-permissions", JSON.stringify(testerPerms));
    }
    return "/admin/course-list";
  }

  localStorage.removeItem("admin-token");

  if (["admin", "super admin", "super_admin"].includes(roleModify)) {
    return "/admin/dashboard";
  }
  if (roleModify === "student" && responseData.is_allow_mobile) {
    return "/student/choose-plan";
  }
  return `/${roleModify}/`;
}
